var map = {
	"./Logo.png": 5303,
	"./Logo.svg": 6850,
	"./TopCornorBall.svg": 9901,
	"./backgroundCurve.png": 1432,
	"./dot.svg": 8896,
	"./dotforul.svg": 4418,
	"./heroimg.png": 535,
	"./heroimg1.svg": 2652,
	"./heroimg2.svg": 4297,
	"./projec3fe.jpg": 1013,
	"./project1fs.jpg": 739,
	"./project2fe.jpg": 7882,
	"./project4fe.jpg": 7287,
	"./project5fs.jpg": 9939,
	"./project6uiux.jpg": 4619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;